'use es6';

import Immutable from 'immutable';
import { cleanObject } from '../utils/formatters';
import uniqueId from 'hs-lodash/uniqueId';
export default class ThemeFeature extends Immutable.Record({
  headline: '',
  imageUrl: '',
  text: '',
  id: ''
}) {
  constructor(values) {
    const data = Object.assign({}, values);
    super(Object.assign({}, cleanObject(data), {
      id: uniqueId('theme-feature-')
    }));
  } // 'id' is used as a unique key that persists as the record updates, for ListTransition


  equals(otherObj) {
    return this.delete('id').toString() === otherObj.delete('id').toString();
  }

}